import { Button } from 'library/components/button';

import { useCmsContent } from '@src/contexts/cms-content-context';
import { RequestLinkReservationModal } from '@src/features/trip-linking/components/request-link-reservation-modal';

import styles from './link-trip-action.module.css';

const LinkTripAction = () => {
  const content = useCmsContent();

  return (
    <div className={styles.wrapper}>
      <RequestLinkReservationModal>
        {(open, isOpen) => (
          <Button variant="tertiary" size="large" onPress={open} aria-haspopup="dialog" aria-expanded={isOpen}>
            {content.addReservationCta}
          </Button>
        )}
      </RequestLinkReservationModal>
    </div>
  );
};

export default LinkTripAction;
